var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00131 3.7583C9.00131 2.78722 9.78852 2 10.7596 2H13.243C14.2141 2 15.0013 2.78722 15.0013 3.75831C15.0013 5.11186 16.4666 5.95781 17.6388 5.28104C18.4798 4.79548 19.5552 5.08362 20.0408 5.92462L21.2824 8.07525C21.768 8.91625 21.4798 9.99162 20.6388 10.4772C19.4666 11.154 19.4666 12.8459 20.6388 13.5227C21.4798 14.0082 21.768 15.0836 21.2824 15.9246L20.0408 18.0752C19.5552 18.9162 18.4798 19.2044 17.6388 18.7188C16.4666 18.0421 15.0013 18.8881 15.0013 20.2416C15.0013 21.2127 14.2141 22 13.2429 22H10.7597C9.78855 22 9.00131 21.2127 9.00131 20.2416C9.00131 18.8881 7.53604 18.0421 6.36382 18.7188C5.52283 19.2044 4.44746 18.9162 3.96191 18.0753L2.72024 15.9246C2.23469 15.0836 2.52284 14.0082 3.36383 13.5227C4.53605 12.8459 4.53606 11.154 3.36383 10.4772C2.52284 9.99162 2.23469 8.91624 2.72024 8.07525L3.96192 5.9246C4.44746 5.08361 5.52284 4.79547 6.36384 5.28102C7.53604 5.95779 9.00131 5.11184 9.00131 3.7583Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 12C16.0013 14.2091 14.2104 16 12.0013 16C9.79217 16 8.00131 14.2091 8.00131 12C8.00131 9.79086 9.79217 8 12.0013 8C14.2104 8 16.0013 9.79086 16.0013 12Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2e32582e89bde10261b9bc86b62871c5.svg";
export { ForwardRef as ReactComponent };